import { Api } from "../config/request";

export default {
  getCarrierModels(carrierId) {
    return Api.get(`/carrier/${carrierId}/vehicle-models`);
  },
  getCarriersList() {
    return Api.get("/carrier");
  },
};
